import { countryIsoMapping } from "@stadium/helpers/country/constants";
import { NOT_ALPHA_NUM_REGEX, NOT_NUMS_REGEX } from "@stadium/helpers/form/constants";

export const normalizePhone = (value, options = {}) => {
  const { showBrackets = false, isInternational = false, isFormattingRequired = true } = options;
  if (!value) {
    return value;
  }

  const onlyNums = value.replace(NOT_NUMS_REGEX, "");
  const maxPhoneLength = isInternational ? 20 : 10;

  if (!isFormattingRequired) {
    if (onlyNums.length > 20) {
      return onlyNums.slice(0, maxPhoneLength);
    }
    return onlyNums;
  }
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 7) {
    return `${onlyNums.slice(0, 3)}  ${onlyNums.slice(3)}`;
  }
  if (!showBrackets) {
    return `${onlyNums.slice(0, 3)}  ${onlyNums.slice(3, 6)}  ${onlyNums.slice(6, maxPhoneLength)}`;
  }
  if (showBrackets) {
    return `(${onlyNums.slice(0, 3)})  ${onlyNums.slice(3, 6)}-${onlyNums.slice(
      6,
      maxPhoneLength,
    )}`;
  }
};
export const normalizeZip = (value, options = {}) => {
  const { usa: usaIso, canada: canadaIso } = countryIsoMapping;
  const { country, isInternational } = options;
  if (!value) return value;
  if (isInternational) {
    return value.slice(0, 20);
  }
  if (country === usaIso) {
    const onlyNums = value.replace(NOT_NUMS_REGEX, "");
    if (onlyNums.length <= 5) {
      return onlyNums;
    }
    return onlyNums.slice(0, 5);
  }
  if (country == canadaIso) {
    const alphaNum = value.replace(NOT_ALPHA_NUM_REGEX, "");
    if (alphaNum.length <= 6) {
      return alphaNum;
    }
    return alphaNum.slice(0, 6);
  }
};
